import authSelectors from 'store/selectors/auth'
import adminActions from 'store/modules/admin'
import publicActions from 'store/modules/booking'

import {
  ROUTE_LOGGED_IN,
  ROUTE_LOGGED_OUT,
} from 'settings'

const auth = {
  user: store => authSelectors.data(store.getState()) ? null : ROUTE_LOGGED_OUT,
  admin: store => authSelectors.isAdmin(store.getState()) ? null : ROUTE_LOGGED_IN,
  guest: store => authSelectors.data(store.getState()) ? ROUTE_LOGGED_IN : null,
}

const routes = [
  {
    name: 'home',
    path: '/'
  },
  {
    name: 'booking_confirm',
    path: '/booking_confirm'
  },
  {
    name: 'help',
    path: '/help',
  },
  {
    name: 'notfound',
    path: '/notfound',
  },
  {
    name: 'book',
    path: '/book/:project',
    redirect: 'book.list',
    children: [
      {
        name: 'list',
        path: '/list',
      },
      {
        name: 'form',
        path: '/:bookingform',
        meta: {
          titleAppend: ':bookingform',
        },
        redirect: 'book.form.start',
        // redirect: 'book.form.calendar',
        // redirectParams: {
        //   date: 'today',
        // },
        children: [{
          name: 'start',
          path: '/start',
        }, {
          name: 'calendar',
          path: '/calendar/:date',
        },{
          name: 'customize',
          path: '/customize',
        },{
          name: 'details',
          path: '/details',
        },{
          name: 'payment',
          path: '/payment',
        },{
          name: 'confirm',
          path: '/confirm',
        }]
      },
    ]
  },
  {
    name: 'admin',
    path: '/admin',
    meta: {
      titlePrepend: 'Admin',
      showMenus: true,
    },
    redirect: (state) => {
      const user = authSelectors.data(state)
      return user ?
        'admin.bookingforms' :
        'admin.login'
    },
    children: [
      {
        name: 'login',
        path: '/login',
        auth: auth.guest,
      },
      {
        name: 'logout',
        path: '/logout',
      },
      {
        name: 'settings',
        path: '/settings',
        auth: auth.user,
      },
      {
        name: 'payment',
        path: '/payment',
        auth: auth.user,
      },
      {
        name: 'projects',
        path: '/projects',
        auth: auth.user,
      },
      {
        name: 'users',
        path: '/users',
        auth: auth.user,
      },
      {
        name: 'updateConfigs',
        path: '/updateConfigs',
        auth: auth.user,
      },
      {
        name: 'bookingforms',
        path: '/bookingforms',
        auth: auth.user,
        redirect: 'admin.bookingforms.list',
        children: [{
          name: 'list',
          path: '/list',
        }, {
          name: 'edit',
          path: '/edit/:id',
          redirect: (state, params) => {
            return {
              name: `admin.bookingforms.edit.${params.id == 'new' ? 'config' : 'calendar'}`,
              params: params.id == 'new' ?
                {} :
                {
                  date: 'today',
                }
            }
          },
          children: [{
            name: 'config',
            path: '/config',
          },{
            name: 'communication',
            path: '/communication',
          },{
            name: 'welcomepage',
            path: '/welcomepage',
          },{
            name: 'embed',
            path: '/embed',
          },{
            name: 'calendar',
            path: '/calendar/:date',
          },{
            name: 'slot',
            path: '/slot/:date/:block_id/:slot_id',
          },{
            name: 'booking',
            path: '/booking/:date/:block_id/:slot_id/:booking_id',
          },{
            name: 'search',
            path: '/search',
          },{
            name: 'schedule',
            path: '/schedule/:date',
          }],
        }]
      },
    ]
  },
]


export default routes